import {useState, useEffect} from 'react';
import Root from "../layouts/Root";
import GameReviewService from "../services/reviews/GameReviewService";
import ToiletReviewService from "../services/reviews/ToiletReviewService";
import AlbumReviewService from "../services/reviews/AlbumReviewService";
import BookReviewService from "../services/reviews/BookReviewService";
import LinkedText from "../components/LinkedText";
import IconText from "../components/IconText";
import {
    faGamepad, 
    faToilet,
    faBook,
    faMusic,
    faCity,
} from "@fortawesome/free-solid-svg-icons";

export default function Reviews() {
    const [albumCount, setAlbumCount] = useState(0);
    const [gameCount, setGameCount] = useState(0);
    const [toiletCount, setToiletCount] = useState(0);
    const [bookCount, setBookCount] = useState(0);

    useEffect(() => {
        const getAlbumCount = async () => {
            try {
                const count = await AlbumReviewService.getCount();
                setAlbumCount(count);
            } catch (error) {
                console.error('Error fetching album count:', error);
            }
        };

        getAlbumCount();
    }, []);

    useEffect(() => {
        const getGameCount = async () => {
            try {
                const count = await GameReviewService.getCount();
                setGameCount(count);
            } catch (error) {
                console.error('Error fetching game count:', error);
            }
        };

        getGameCount();
    }, []);

    useEffect(() => {
        const getToiletCount = async () => {
            try {
                const count = await ToiletReviewService.getCount();
                setToiletCount(count);
            } catch (error) {
                console.error('Error fetching toilet count:', error);
            }
        };

        getToiletCount();
    }, []);

    useEffect(() => {
        const getBookCount = async () => {
            try {
                const count = await BookReviewService.getCount();
                setBookCount(count);
            } catch (error) {
                console.error('Error fetching book count:', error);
            }
        };

        getBookCount();
    }, []);

    const countStyle = {
        fontWeight: 'bold',
        fontSize: '1.2em',
        textDecoration: 'underline',
    };

    const rightContent = (
        <div>
            <h1><IconText icon={faGamepad} text={"Game"}></IconText></h1>
            <p>I have reviewed <span style={countStyle}>{gameCount}</span> games so far. Click <LinkedText
                to={'/reviews/game'} text={'here'}></LinkedText> to see them.</p>

            <h1><IconText icon={faToilet} text={"Toilet"}></IconText></h1>
            <p>I have reviewed <span style={countStyle}>{toiletCount}</span> toilets so far. Click <LinkedText
                to={'/reviews/toilet'} text={'here'}></LinkedText> to see them.</p>

            <h1><IconText icon={faBook} text={"Book"}></IconText></h1>
            <p>I have reviewed <span style={countStyle}>{bookCount}</span> books so far. Click <LinkedText
                to={'/reviews/book'} text={'here'}></LinkedText> to see them.</p>
            
            <h1><IconText icon={faMusic} text={"Album"}></IconText></h1>
            <p>I have reviewed <span style={countStyle}>{albumCount}</span> albums so far. Click <LinkedText
                to={'/reviews/album'} text={'here'}></LinkedText> to see them.</p>

            <h1><IconText icon={faCity} text={"City"}></IconText></h1>
            <p>Coming soon...</p>
        </div>
    )

    return (
        <div className="reviews-page">
            <Root rightContent={rightContent}/>
        </div>
    )
}
